import axios from "axios";
import {API_URL} from "@env";

export const getPackages = () => {
    return axios.get(API_URL + `/packages`);
}

export const checkUpdate = () => {
    return axios.get(API_URL + '/kota-version');
}